
import React from "react";
import { getIcon } from "./AnalogHorrorIcons";
import { Save } from "lucide-react";
import { HorrorTitle } from "./HorrorTitle";
import { PopupType } from "./types";

interface AnalogHorrorContentProps {
  messageType: PopupType;
  displayMessage: string;
  isLoadingMessage: boolean;
  isSaving: boolean;
  glitching: boolean;
  onSave: () => void;
  onClose: () => void;
}

export const AnalogHorrorContent = ({
  messageType,
  displayMessage,
  isLoadingMessage,
  isSaving,
  glitching,
  onSave,
  onClose
}: AnalogHorrorContentProps) => {
  return (
    <>
      <HorrorTitle messageType={messageType} glitching={glitching} />
      
      {/* Icon and message */}
      <div className="flex items-center justify-center mb-3">
        <div className="flex flex-col items-center">
          {getIcon(messageType)}
          <div className={`mt-3 text-center max-w-sm ${glitching ? "tracking-widest" : "tracking-wide"}`}>
            <p className="font-medium" style={{ maxWidth: "240px", margin: "0 auto" }}>
              {displayMessage}
            </p>
          </div>
        </div>
      </div>
      
      {/* Timestamp */}
      <div className="text-center text-xs opacity-70 mt-3 font-mono">
        REF: {Math.floor(Math.random() * 999999).toString().padStart(6, '0')}
        <br />
        {new Date().toISOString().replace('T', ' ').substring(0, 19)}
      </div>
      
      {/* Action buttons */}
      <div className="mt-3 flex space-x-2">
        {/* Show save button only for non-achievement popups */}
        {messageType !== "achievement" && (
          <button 
            onClick={onSave}
            disabled={isLoadingMessage || isSaving || displayMessage === "CONNECTING TO MONOLITH..."}
            className="flex-1 border border-current py-1.5 px-2 hover:bg-gray-900 transition-colors duration-200 uppercase tracking-widest text-sm flex items-center justify-center gap-2"
          >
            {isSaving ? (
              <span className="animate-pulse">SAVING...</span>
            ) : (
              <>
                <Save className="h-4 w-4" />
                ARCHIVE
              </>
            )}
          </button>
        )}
        
        {/* Close button - now takes full width for achievement popups */}
        <button 
          onClick={onClose}
          className={`border border-current py-1.5 px-2 hover:bg-gray-900 transition-colors duration-200 uppercase tracking-widest text-sm ${messageType === "achievement" ? "w-full" : "flex-1"}`}
        >
          ACKNOWLEDGE
        </button>
      </div>
    </>
  );
};
